import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';
import { CommonInputDialogComponent } from 'src/@order/dialogs/common-input-dialog/common-input-dialog.component';
import { WalletInfoDialogComponent } from 'src/@order/dialogs/wallet-info-dialog/wallet-info-dialog.component';
import { AuthServiceLocal } from 'src/@order/services/auth.service';

@Component({
  selector: 'app-wallet-layout',
  templateUrl: './wallet-layout.component.html',
  styleUrls: ['./wallet-layout.component.scss'],
})
export class WalletLayoutComponent implements OnInit {
  // public walletAmount:BehaviorSubject<number>;
  country: string;
  loading: boolean = true;
  // transactions = [
  //   {
  //     time : new Date().getTime(),
  //     refId : 84579897988,
  //     status : 1,
  //     amount : 56,
  //   },
  //   {
  //     time : new Date().getTime(),
  //     refId : 98512084518,
  //     status : 2,
  //     amount : 56,
  //   },
  //   {
  //     time : new Date().getTime(),
  //     refId : 985120854105,
  //     status : 1,
  //     amount : 120,
  //   },
  // ]

  walletData: any;

  constructor(
    public _auth: AuthServiceLocal,
    private _matDialog: MatDialog,
    private _matSnackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.country = localStorage.getItem('country');
    // this.walletAmount = new BehaviorSubject(0);
    this._auth.getDashboardData({});
    this.getAllTransactions();
    // this._auth.getDashboardData({}).subscribe((res:any) => {
    //   if(res.response == 1){
    //       this.walletAmount.next(res?.data?.balance || 0);
    //     }else{
    //         this.walletAmount.next(0);
    //     }
    // })

    this._auth.getDashboardData({});
  }

  public openInfoDialog() {
    const dialog = this._matDialog.open(WalletInfoDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '580px',
      data: {
        hideBtn: true,
      },
    });
  }

  getAllTransactions() {
    this._auth.getPDASTransactionHistoty({}).subscribe((res: any) => {
      if (res?.response) {
        this.walletData = res.data;
        this.loading = false;
      } else {
        this.walletData = null;
        this.loading = false;
        this._matSnackBar.open(res.message, 'OKAY', { duration: 3000 });
      }
    });
  }

  onAddWalletFund() {
    const dialog = this._matDialog.open(CommonInputDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      width: '480px',
      data: {
        title: 'phlenu wallet',
        placeholder: 'Enter Amount',
        btnLabel: 'fund wallet',
        errorMessage: 'Fund wallet amount is required',
        walletData: this.walletData ? this.walletData : null,
        remark: true,
      },
    });

    dialog.afterClosed().subscribe((res) => {
      console.log('dialog res', res);
      if (res?.inputField) {
        this.onAddFundWallet(res?.inputField, res?.remark);
      }
    });
  }

  onAddFundWallet(amount, remark: any) {
    const payload = {
      amount: amount,
      country: localStorage.getItem('country'),
      isWeb: 1,
      email: JSON.parse(localStorage.getItem('authUser')).email,
      remarks: remark || '',
    };
    console.log('payload', payload);
    this._auth.addFundToWallet(payload).subscribe((res: any) => {
      if (res.response) {
        this._auth.getDashboardData({});
        window.open(res.data.payUrl, '_self');
      } else {
        this._matSnackBar.open(res.message, 'OKAY', { duration: 3000 });
      }
    });
  }

  public convert(value) {
    return Math.abs(value);
  }
}
